// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2424) return "static/chunks/2424-c6169f9c1b885ab1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16","6717":"770e1402"}[chunkId] || chunkId) + "." + {"1675":"64854d2e9e5231a1","2442":"61de52e466f17211","3789":"94a4562156d2bc56","5443":"7915a73e07184142","6058":"f202e33cc1cce374","6350":"5e4d98abc18bb702","6717":"5b9bf59c9fe610e8","7524":"2bc21ae6a7fe013a","9657":"efed07e81240117b"}[chunkId] + ".js";
};